"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "difference", {
    enumerable: true,
    get: function() {
        return difference;
    }
});
const _extends = require("@swc/helpers/_/_extends");
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _isEqual = /*#__PURE__*/ _interop_require_default._(require("lodash/isEqual"));
function difference(existing, incoming, identifier = (item)=>item, comparator = (a, b)=>(0, _isEqual.default)(a, b)) {
    var _existing_map;
    const existingMap = new Map((_existing_map = existing == null ? void 0 : existing.map((i)=>[
            identifier(i),
            i
        ])) != null ? _existing_map : []);
    const reduced = (incoming != null ? incoming : []).reduce((acc, i)=>{
        if (!i) return acc;
        const id = identifier(i);
        if (!id) {
            acc.create.push(i);
        } else {
            if (existingMap.has(id)) {
                const e = existingMap.get(id);
                if (!comparator(e, i)) {
                    acc.update.push({
                        existing: e,
                        incoming: i
                    });
                }
                acc.remove.delete(id);
            } else {
                acc.create.push(i);
            }
        }
        return acc;
    }, {
        create: [],
        remove: existingMap,
        update: []
    });
    const out = _extends._({}, reduced, {
        remove: Array.from(reduced.remove.values())
    });
    return out;
}

//# sourceMappingURL=difference.js.map